import Biographie from "../../components/Biographie";
import SEO from "../../components/SEO";
import { pageSEOData } from "../../data/seoData";

const BiographiePage: React.FC = () => {
  const seo = pageSEOData.biographie;

  return (
    <div className="page-animation">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        ogImage={seo.ogImage}
      />
      <Biographie />
    </div>
  );
};

export default BiographiePage;
